import { Component, OnInit, Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { DialogModelConfirm } from '../dialog-confirm/model';
import { DialogModelUnBlockUser } from './model';
import { AdminService } from "src/app/core/services/api/admin.service";
import { PopupService } from "src/app/core/services/popup/popup.service";

@Component({
  selector: 'app-unblock-user',
  templateUrl: './unblock-user.component.html',
  styleUrls: ['./unblock-user.component.scss']
})
export class UnblockUserComponent implements OnInit {

  reasons = [];
  currReason = "";
  comment = "";
  selectedCount = 0;

  constructor(
    public dialogRef: MatDialogRef<UnblockUserComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogModelUnBlockUser,
    private adminService: AdminService,
    private popupService: PopupService
  ) {}

  ngOnInit(): void {
    this.popupService.openProgress();
    this.adminService.getUnBlockReasons().subscribe(
      response => {
        this.reasons = response.data;
        if (this.reasons.length > 0) {
          this.currReason = this.reasons[0];
        }
        this.selectedCount = 0;
        this.popupService.closeProgress();
      },
      error => {
        this.popupService.closeProgress();
        this.dialogRef.close(false);
        this.popupService.openError(error.error.error.error);
      }
    )
  }

  selectReason(e) {
    this.selectedCount = 0;
    this.reasons.map(reason => {
      if (reason.selected) {
        this.selectedCount = this.selectedCount + 1;
      }
    })
  }

  unblock() {
    const body = {
      reasons: [],
      comment: this.comment
    };
    this.reasons.map(reason => {
      if (reason.selected) {
        body.reasons.push(reason.reason)
      }
    })
    this.dialogRef.close(body);
  }

  cancel() {
    this.dialogRef.close(false);
  }
}
